var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("g",{"fillRule":"nonzero","fill":"none","key":1},[React.createElement("rect",{"fill":"#002B41","width":"29","height":"29","rx":"3","key":0}),React.createElement("path",{"d":"M10.622 15.04h1.798v7.478c0 .148.118.268.264.268h3.049c.146 0 .264-.12.264-.268v-7.443h2.067a.266.266 0 00.263-.236l.314-2.753a.27.27 0 00-.065-.209.263.263 0 00-.198-.09h-2.38v-1.725c0-.52.277-.784.824-.784h1.556c.146 0 .265-.12.265-.267V6.484a.266.266 0 00-.265-.268h-2.145l-.098-.002c-.372 0-1.666.074-2.688 1.024-1.133 1.053-.975 2.313-.938 2.532v2.018h-1.887a.266.266 0 00-.265.267v2.718c0 .148.119.267.265.267z","fill":"#FFF","key":1})])]);
}

IconFacebook.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
